import {useNavigate} from 'react-router-dom';
import {useSelector} from 'react-redux';
import Selector from '../../../selectors/pages/main/balance';
import Timeout from '../cashback_new/timeout';
import levels from '../cashback_new/levels';

export default () => {
    const navigate = useNavigate(),
          {wallet} = useSelector(Selector);

    return (
        <div className="tasks-list" style={{margin: "0px 20px"}}>
            <div className="task">
                <div className="task-header">
                    <div className={`icon cashback`}>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.5249 14.235H5.47491C5.15991 14.235 4.8074 13.9875 4.7024 13.6875L1.59741 5.00252C1.15491 3.75752 1.67241 3.37502 2.73741 4.14002L5.66241 6.23252C6.14991 6.57002 6.70491 6.39752 6.91491 5.85002L8.23491 2.33252C8.65491 1.20752 9.35241 1.20752 9.77241 2.33252L11.0924 5.85002C11.3024 6.39752 11.8574 6.57002 12.3374 6.23252L15.0824 4.27502C16.2524 3.43502 16.8149 3.86252 16.3349 5.22002L13.3049 13.7025C13.1924 13.9875 12.8399 14.235 12.5249 14.235Z" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M4.875 16.5H13.125" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M7.125 10.5H10.875" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>

                    <div className="right-block">
                        <div className="task-title">VIP Cashback</div>
                        <div className="task-all" onClick={e => navigate('/cashback')}>
                            View more
                        </div>
                    </div>
                </div>

                <div className="task-body">
                    <div className="text">
                        Be an active player and get a weekly cashback and other benefits!
                    </div>

                    {wallet.cashback.balance == 0 ? (
                        <div className="claim" onClick={e => navigate('/deposit')}>Deposit</div>
                    ) : (
                        <Timeout task_key={"main_cashback"} timeout={wallet.cashback.timestamp} short={true} activeClass={"claim"} inactiveClass={"claim inactive"} balance={wallet.cashback.balance} />
                    )}
                </div>

                {wallet.cashback.next_level_preset && (
                    <div className="progress">
                        <div className="line">
                            <div className="line-progress" style={{width: `${((wallet.cashback.deposits / wallet.cashback.next_level_preset.amounts.from)*100)}%`}}></div>
                        </div>
                        <div className="ticks cashback">
                            <div className={`tick active`}>
                                {wallet.cashback.level} <span>{wallet.cashback.level_preset.cashback}%</span>
                            </div>

                            <div className={`tick`}>
                                {wallet.cashback.next_level_preset.key} <span>{wallet.cashback.next_level_preset.cashback}%</span>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}